module.exports = __webpack_public_path__ + "img/logout.478d6ad9.svg";